export default __webpack_public_path__ + "static/careers2-45c12c6491329d5a4b52b71178e56a3d.webp";